import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import { P1_RK } from '../../../../../Widgets/DataPainterWidget/P1MeterWidget/p1MeterConst';
import commandEngine from './CommandEngine';
import { CMD_P1METER_REGISTRY_KEY, META_TYPE, META_VER } from './p1MeterCommandRegisteryType';

/**
 * Registers the /p1 command with the CommandEngine.
 * /p1 — opens/refocuses the P1 meter health card (single instance, target=p1).
 */
export function registerP1MeterCommand() {
    commandEngine.register('/p1', {
        hint: 'open P1 meter card (power, amps, last update)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_P1METER_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: P1_RK }, { rk: P1_RK });
        },
    });
}
